export default __webpack_public_path__ + "static/media/steller-icon.3a14f0d1.svg";